"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const TableSortLabel_1 = __importDefault(require("@material-ui/core/TableSortLabel"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const layouts_1 = require("../../../../layouts");
const constants_1 = require("../../constants");
function TableHead(_a) {
    var { headerGroups, styles } = _a, props = __rest(_a, ["headerGroups", "styles"]);
    return (react_1.default.createElement(TableHead_1.default, { "data-testid": props['data-testid'] }, headerGroups.map((headerGroup) => (react_1.default.createElement(TableRow_1.default, Object.assign({}, headerGroup.getHeaderGroupProps(), { className: styles.tableHeadRow }), headerGroup.headers.map((column) => {
        var _a, _b, _c;
        return column.id !== constants_1.SEARCH_COLUMN_NAME && (react_1.default.createElement(TableCell_1.default, Object.assign({}, column.getHeaderProps()),
            react_1.default.createElement(layouts_1.Stack, { spacing: "xs" },
                column.canSort ? (react_1.default.createElement(TableSortLabel_1.default, Object.assign({}, column.getSortByToggleProps(), { active: column.isSorted, direction: column.isSortedDesc ? 'desc' : 'asc', IconComponent: ArrowDropDown_1.default, className: styles.cellAlign }),
                    react_1.default.createElement("span", null, (_a = column.render) === null || _a === void 0 ? void 0 : _a.call(column, 'Header')))) : (react_1.default.createElement("span", null, (_b = column.render) === null || _b === void 0 ? void 0 : _b.call(column, 'Header'))),
                react_1.default.createElement("div", null, column.canFilter ? (_c = column.render) === null || _c === void 0 ? void 0 : _c.call(column, 'Filter') : null),
                react_1.default.createElement("div", Object.assign({}, column.getResizerProps(), { className: styles.resizer })))));
    }))))));
}
exports.default = TableHead;
//# sourceMappingURL=index.js.map